const initialState = {
  pageData: [],
  fields: [],
  pageKey: "",
};

export function OriginalTableData(state = initialState, { type, payload }) {
  switch (type) {
    case "SET_ORIGINAL_PAGE_DATA":
      return { ...state, pageData: payload };
    case "SET_ORIGINAL_FIELDS":
      return { ...state, fields: payload };
    case "SET_ORIGINAL_PAGE_KEY":
      return { ...state, pageKey: payload };
    case "SET_ORIGINAL_UPDATE_DATA": // Assuming this is for bulk updates
      return { ...state, ...payload };
    default:
      return state;
  }
}
